<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">구분</th>
          <td>
            <div class="item">
              <span class="ui_chkbox primary lgray" v-for="parent in categoryParentList">
                <input type="radio" :value="parent.seq" v-model="categoryParentType">
                <label for="">
                  <span class="txt">{{ parent.name }}</span>
                </label>
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">카테고리명</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="카테고리명을 입력하세요." v-model="name">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">사용여부</th>
          <td>
            <div class="item">
              <span class="ui_chkbox primary lgray untxt">
                <input
                  type="checkbox" 
                  name="edu" 
                  v-model="useYn" 
                  true-value="Y" 
                  false-value="N"
                ><label for=""></label>
                </span>
            </div>
          </td>
        </tr>
        
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createCategory">등록</button>
      <button type="button" class="bt_base gray large_h" @click="toList">취소</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';


const adminCategoryModule = 'adminCategoryModule'

export default {
  data() {
    return {
      categoryParentType: '',
      name: '',
      useYn: 'N'
    }
  },

  methods: {
    ...mapActions(adminCategoryModule, [
      'requestCategoryParentList',
      'requestCreateCategory'
    ]),

    toList () {
      this.$router.push({ name: "CategoryManageListPage" })
    },

    async createCategory () {
      if (this.categoryParentType === '') {
        alert('구분을 선택하세요')
        return
      }
      const { categoryParentType, name, useYn } = this
      if (await this.requestCreateCategory({ categoryParentType, name, useYn })) {
        alert('카테고리가 등록됐습니다')
        this.$router.push({ name: "CategoryManageListPage" })
      }
    }
  },

  computed: {
    ...mapState(adminCategoryModule, ['categoryParentList'])
  },

  mounted() {
    this.requestCategoryParentList()
  }
}
</script>
<style lang="">
    
</style>